import MaintenanceContractsView from './MaintenanceContracts'
export default MaintenanceContractsView
